(() => {
  if (!window.swinger.consent.isAllowed('marketing')) {
    return;
  }

  window.swinger.resourceLoader.script('https://t.adcell.com/js/trad.js', () => {
    if (window.Adcell && window.Adcell.Tracking) {
      window.Adcell.Tracking.track();
    }
  });
})();
